module.exports = __webpack_public_path__ + "static/media/media-01.477e0c74.png";